import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_USER_DEFINITIONS,
  ADD_NEW_USER_DEFINITION,
  UPDATE_USER_DEFINITION,
  DELETE_USER_DEFINITION,
  CREATE_NEW_USER_DEFINITION,
  CONFIRM_NEW_USER_DEFINITION,
  INSERT_USER_KEYS,
  GET_USER_BY_USERNAME,
  GET_USERENCKEY_BY_MERCHANTGUID,
  GET_APIKEY_BY_MERCHANTID,
  GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID,
  GET_USER_BY_USERNAME_SYNC,
  GET_USER_DEFINITIONS_BY_USERNAME
} from "./actionTypes"

import {
  getUserDefinitionsSuccess,
  addUserDefinitionSuccess,
  updateUserDefinitionSuccess,
  deleteUserDefinitionSuccess,
  addNewCreateUserAcountSuccess,
  confirmUserAcountSuccess,
  insertUserKeysSuccess,
  getUserByUserNameSuccess,
  getUserEncKeyByMerchantGuidSuccess,
  getUserEncryptionKeyByMerchantGuidSuccess,
  getApiKeyByMerchantIdSuccess,
  getUserByUserNameSyncSuccess,
  getUserDefinitionsByUserNameSuccess,
  userDefinitionsApiError
} from "./actions"

import {
  getUserDefinitions,
  addNewUserDefinition,
  updateUserDefinition,
  deleteUserDefinition,
  addNewCreateUserAcount,
  insertUserKeys,
  getUserByUserNameForKey,
  getUserEncKeyByMerchantGuid,
  getUserEncryptionKeyByMerchantGuid,
  confirmUserAcount,
  getUserByUserNameSync,
  getApikeyByMerchantId,
  getUserDefinitionsByUserName
} from "../../../helpers/backend_helper/backend_helper"

import { toast, Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchUserDefinitions() {
  try {
    const response = yield call(getUserDefinitions)
    yield put(getUserDefinitionsSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* fetchUserDefinitionsByUserName({ payload: userName })  {
  try {
    const response = yield call(getUserDefinitionsByUserName, userName)
    yield put(getUserDefinitionsByUserNameSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onAddNewUserDefinition({ payload: userDefinition }) {
  try {
    const response = yield call(addNewUserDefinition, userDefinition)
    yield put(addUserDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {

    yield put(userDefinitionsApiError(error))
  }
}

function* onUpdateUserDefinition({ payload: userDefinition }) {
  try {
    const response = yield call(updateUserDefinition, userDefinition)
    yield put(updateUserDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onDeleteUserDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteUserDefinition, guid)
    yield put(deleteUserDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onCreateNewUserDefinition({ payload: user }) {
  try {
    const response = yield call(addNewCreateUserAcount, user)
    yield put(addNewCreateUserAcountSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onConfirmNewUserDefinition({ payload: userDefinition }) {
  try {
    const response = yield call(confirmUserAcount, userDefinition)
    yield put(confirmUserAcountSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onInsertUserKeys({ payload: record }) {
  try {
    const response = yield call(insertUserKeys, record)
    yield put(insertUserKeysSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onGetUserByUserName({ payload: userName }) {
  try {
    const response = yield call(getUserByUserNameForKey, userName)
    yield put(getUserByUserNameSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onGetUserByUserNameSync({ payload: userName }) { 
  try {
    const response = yield call(getUserByUserNameSync, userName)
    yield put(getUserByUserNameSyncSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onGetUserEncKeyByMerchantGuid({ payload: merchantGuid }) {
  try {
    const response = yield call(getUserEncKeyByMerchantGuid, merchantGuid)
    yield put(getUserEncKeyByMerchantGuidSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onGetUserEncryptionKeyByMerchantGuid({ payload: merchantGuid }) {
  try {
    const response = yield call(getUserEncryptionKeyByMerchantGuid, merchantGuid)
    yield put(getUserEncryptionKeyByMerchantGuidSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* onGetApiKeyByMerchantId({ payload: merchantId }) {
  try {
    const response = yield call(getApikeyByMerchantId, merchantId)
    yield put(getApiKeyByMerchantIdSuccess(response))
  } catch (error) {
    yield put(userDefinitionsApiError(error))
  }
}

function* userManagementSaga() {
  yield takeEvery(GET_USER_DEFINITIONS, fetchUserDefinitions)
  yield takeEvery(ADD_NEW_USER_DEFINITION, onAddNewUserDefinition)
  yield takeEvery(CREATE_NEW_USER_DEFINITION, onCreateNewUserDefinition)
  yield takeEvery(UPDATE_USER_DEFINITION, onUpdateUserDefinition)
  yield takeEvery(DELETE_USER_DEFINITION, onDeleteUserDefinition)
  yield takeEvery(CONFIRM_NEW_USER_DEFINITION, onConfirmNewUserDefinition)
  yield takeEvery(INSERT_USER_KEYS, onInsertUserKeys)
  yield takeEvery(GET_USER_BY_USERNAME, onGetUserByUserName)
  yield takeEvery(GET_USER_BY_USERNAME_SYNC, onGetUserByUserNameSync)
  yield takeEvery(GET_USERENCKEY_BY_MERCHANTGUID, onGetUserEncKeyByMerchantGuid)
  yield takeEvery(GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID, onGetUserEncryptionKeyByMerchantGuid)
  yield takeEvery(GET_APIKEY_BY_MERCHANTID, onGetApiKeyByMerchantId)
  yield takeEvery(GET_USER_DEFINITIONS_BY_USERNAME, fetchUserDefinitionsByUserName)
}

export default userManagementSaga